import React, { useState, useEffect } from "react";
import Modaleditproduct from "./modaleditproduct";
import { dataproduct } from "../queue/datalist";
import Input from "./../wms/input";
import { getFacDaily } from "../../services/wms";
import ScrollToTop from "../common/ScrollToTop";

const Cardeditproduct = () => {
  const [isOpen, setisOpen] = useState(false);
  const [dataproduct, setdataproduct] = useState([]);
  const [name, setname] = useState("");
  const [search, setsearch] = useState("");
  const [list, setList] = useState([
    {
      identityId: "12345678",
      cusid: "444",
      header: "ข้อมูลสินค้า",
      fname: "varaphong",
      lname: "Sangondee",
    },
  ]);
  const handleOnchang = (event) => {
    setname(event.target.value);
  };

  const handleOnclick = () => {
    setsearch(name);
   
  };
  const handleCancle = () => {
    setisOpen(false);
  };
  const handleonClickclose = (event) => {
    setList(false);
  };
  const handleonClikisopen = (event) => {
    setisOpen(true);
  };
  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getFacDaily("820-641100024", search);

      if (result) {
        setdataproduct(result);
      }
    };
    loadData();
  }, [search]);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-3 ">
          <div className="input-group">
            <Input
              label="ค้นหาชื่อเลขที่ใบชั่ง"
              onChange={handleOnchang}
              value={name}
              search="ค้นหา"
              onClick={handleOnclick}
            />
          </div>
        </div>
        <div className="col-lg-6 d-flex justify-content-center">
          <div className="row">
            <label htmlFor="name">&nbsp; </label>
            <span className="badge rounded-pill bg-primary fs-5">
              <i className="bi bi-gear me-2"></i>
              แก้ไขชื่อลูกค้า
            </span>
          </div>
        </div>
      </div>
      {dataproduct &&
        dataproduct.length > 0 &&
        dataproduct.map((item, index) => (
          <div
            className="card1 shadow  mt-2 "
            key={index}
          >
            <div className="row m-1">
              <div className="col-xs-6 col-sm-4 col-md-2 lg-1 mt-2">
                <span className="badge rounded-pill bg-primary mb-1">
                  {item.id}
                </span>

                <span className="badge text-primary fs-6">{item.weightno}</span>
              </div>

              <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                <div>
                  <h6>
                    ประเภทสินค้า :
                    <small style={{ fontSize: 14 }}> {item.typename}</small>
                  </h6>
                </div>
                <div>
                  <h6>
                    ชื่อสินค้า :
                    <small style={{ fontSize: 14 }}> {item.productname}</small>
                  </h6>
                </div>

                <div />
              </div>
              <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
                <div>
                  <h6>
                    วัตถุประสงค์ :
                    <small style={{ fontSize: 14 }}>{item.aimno} </small>
                  </h6>
                </div>

                <h6>
                  สถานที่จัดเก็บ :
                  <small style={{ fontSize: 14 }}> {item.storename}</small>
                  &nbsp;
                </h6>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                <h6>
                  ต้นทางสินค้า :
                  <small style={{ fontSize: 14 }}> {item.customername}</small>
                </h6>
                <h6>
                  ปลายทางสินค้า :
                  <small style={{ fontSize: 14 }}> {item.destname}</small>
                </h6>
              </div>

              {/* <div className=" col-xs-6 col-sm-4 col-md-2 lg-1">
              
                  <h6>
                  ต้นทางสินค้า :
                  <small style={{ fontSize: 14 }}> {item.customername}</small>
                </h6>
              </div> */}
              <div className="col-lg-4  d-flex align-items-center d-flex justify-content-end">
                <i
                  onClick={() => handleonClikisopen()}
                  className="bi bi-trash me-4 text-danger"
                  style={{ fontSize: "25px", cursor: "pointer" }}
                ></i>
                <i
                  onClick={() => handleonClikisopen()}
                  className="bi bi-pencil-square me-2 text-info"
                  style={{ fontSize: "25px", cursor: "pointer" }}
                ></i>
              </div>
            </div>
          </div>
          
        ))}
          {<ScrollToTop />}
      <Modaleditproduct
        onCancel={handleCancle}
        id={0}
        //onClick={handleonClick}
        list={list}
        isOpen={isOpen}
      />

    </div>
  );
};

export default Cardeditproduct;
